import React, { useContext, useEffect } from 'react';
import Header from "../common/components/header/index";
import { IndexData } from '../common/index-context';
import { WithLangData } from '../common/lang-data';
import CustomizeQuestionsModal from "../common/components/customize-questions-modal/customize-questions-modal";
import EntityModal from "./components/entity-modal/index";
import Comparisons from "./components/comparisons";

const AppInner = () => {
  const {
    init, data, loadData, openConceptAfterReload,
    customizedQuestionData, showEntityModal
  } = useContext(IndexData);

  useEffect(() => {
    loadData(null, null, null, null, {}, openConceptAfterReload);
  }, []);

  const reports = [
    {
      title: 'Ads Comparison Report',
      name: 'concept_comparison_adcept',
      kinds: [ 'pptx', 'xlsx' ],
      customFontSize: true
    },
    { title: 'Ads Comparison - 5-point Scales Report', name: 'five_point', kinds: [ 'xlsx' ] },
    { title: 'Individual Ad Reports', name: 'adcept_individual_item', kinds: [ 'pptx', 'xlsx' ] },
    { title: 'All Ads Verbatims Report', name: 'adcept_all_verbatims', kinds: [ 'xlsx' ] }
  ];
  if (init.isInternal) {
    reports.push({ title: 'Disqualified Respondents Report', name: 'disqualified', kinds: [ 'xlsx' ] });
    reports.push({ title: 'All Respondents Answers', name: 'adcept_all_respondents', kinds: [ 'xlsx' ] });
    reports.push({ title: 'Completes & Disqualified Report', name: 'completes_disqualified', kinds: [ 'xlsx' ] });
    reports.push({ title: 'Quota Details', name: 'quotas_details', kinds: [ 'xlsx' ] });
  }

  const sortGroups = [
    'five_point_scale',
    'adcept_attribute_ratings1',
    'adcept_attribute_ratings2',
    'preference'
  ];
  sortGroups.push({ group_name: 'custom_metric', custom: 'custom_metrics' });

  return (
    <div className="content -loading-wrapper tour-parent-header">
      <Header
        reports={ reports }
        plural="ads"
        sortGroups={ sortGroups }
      />
      <WithLangData
        langCode={ data.language_code }
        langName={ data.language_name }
      >
        <Comparisons />
        { showEntityModal && <EntityModal /> }
        { customizedQuestionData && <CustomizeQuestionsModal /> }
      </WithLangData>
    </div>
  );
};

export default AppInner;
